const config = {
  cookie_prefix: 'iiws-',
  footer_conf: [{ copyright: '版权 © 2021-2022, 宁波弘讯科技股份有限公司, 保留所有权利。' }],
};
export { config };
